// Rain intensity over time (presentation only): drifts between drizzle and downpour over a few minutes, from the wall
// clock, so everyone in a room hears and sees roughly the same weather. Shared by the rain sound and the rain sprites.
import { WORLD, type Rect } from '../../common/src/data';
import { GameMap, T, TILE, tileAt, inTileRect } from '../../common/src/map';

/** 0.15 (drizzle) .. 1 (downpour) at wall-clock time `ms` */
export function rainIntensity(ms = Date.now()): number {
  const t = ms / 1000;
  // two slow swells (about 4 and 11 minutes) plus a gentle wobble; squared so heavy rain is the rarer state
  const v = 0.5 + 0.3 * Math.sin(t * 2 * Math.PI / 240) + 0.2 * Math.sin(t * 2 * Math.PI / 660 + 1.7) + 0.06 * Math.sin(t * 2 * Math.PI / 37);
  const c = Math.min(1, Math.max(0, v));
  return 0.15 + 0.85 * c * c;
}

/** Where the listener is, for the rain sound: open street, a narrow alley, under a roof, or inside a car. */
export type RainPlace = 'street' | 'alley' | 'covered' | 'car';

const overlaps = (a: Rect, b: Rect) => a.x < b.x + b.w && b.x < a.x + a.w && a.y < b.y + b.h && b.y < a.y + a.h;
/** station concourses (plazas crossing the rail line) are under the station roof */
const COVERED = WORLD.plazas.filter(p => WORLD.rails.some(r => overlaps(r, p)));

/** the place at world px (x, y) */
export function rainPlace(m: GameMap, x: number, y: number, inCar: boolean): RainPlace {
  if (inCar) return 'car';
  const tx = Math.floor(x / TILE), ty = Math.floor(y / TILE);
  if (COVERED.some(c => inTileRect(tx, ty, c))) return 'covered';
  return tileAt(m, tx, ty) === T.ALLEY ? 'alley' : 'street';
}
